import { DomainEntity, Id, Json } from "@homeleite/arch";
import { ProducerSummary } from "../../../producers";
import { PropertySummary } from "../../../properties";
import { AnimalSummary } from "../../animal";
import { AnimalEvent } from "../animal-event";
import { EventType } from "../event-type";
import { AuditData } from '../../auditData';

export class Dry implements DomainEntity, AnimalEvent {

    constructor(
        public id: string = Id.gen(),
        public date: Date = null,
        public animal: AnimalSummary = null,
        public producer: ProducerSummary = null,
        public property: PropertySummary = null,
        public type: string = EventType.DRY.name,
        public created: Date = null,
        public auditData: AuditData = null,
        public milkControlId: string = null
    ) { }

    toJson(): any {
        return Json.to.simple(this, {
            date: this.date?.toISOString() ?? null,
            animal: this.animal?.toJson() ?? null,
            producer: this.producer?.toJson() ?? null,
            property: this.property?.toJson() ?? null
        });
    }

    static fromJson(json: any): Dry {
        return json ? Json.from.simple(json, Dry, {
            date: json.date ? new Date(json.date) : null,
            animal: json.animal ? AnimalSummary.fromJson(json.animal) : null,
            producer: json.producer ? ProducerSummary.fromJson(json.producer) : null,
            property: json.property ? PropertySummary.fromJson(json.property) : null,
            created: json.created ? new Date(json.created) : null,
            auditData: json.auditData ? AuditData.fromJson(json.auditData) : null
        }) : null;
    }
}
